module.exports = __webpack_public_path__ + "media/images/icons/twotone/play-square-20a79c0cb9b94d40d96bbfa8582a7f0f.svg";